import { useState, useEffect } from 'react'
import { useNavigate  } from 'react-router-dom'

import api from '../utils/api'
import { toast } from 'react-toastify';

export default function useAuth() {

    const [authenticated, setAuthenticated] = useState(false)
    const navigate  = useNavigate()
    const [user, setUser] = useState({})

    useEffect(()=>{
        const token = localStorage.getItem('token')

        if(token){
            api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`
            setAuthenticated(true)
        }
    }, [])

    
    async function createUser(user) {

        try {
            const data = await api.post('/users/register', user).then((response) => {
                return response.data
            })

            
            toast.success("Usuário criado!", {
                // position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });

            //   await authUser(data)
            
            
        } catch (error) {
            // tratar erro
            console.log(error)
            toast.error("Ops! " + error.response.data.message, {
                // position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
        }
    }

    // async function authUser(data){

    //     setAuthenticated(true)

    //     localStorage.setItem('token', JSON.stringify(data.token))

    //     data.role === 'tecnico' ? navigate('/app/myrequests') : data.role === 'warehouse' ? navigate('/app/warehouse') : navigate('/app')
    //     // window.location.href = '/app';

    // }

    // async function login(user) {

    //     let message = ''

    //     try {

    //         const data = await api.post('/users/login', user).then((response) => {
    //             return response.data
    //         })
    //         await authUser(data)
    //         message = 'Login realizado com sucesso'
    //         toast.success(message);

    //     } catch (error) {
    //         message = error.response.data.message
    //         toast.error("Ops! " + message);
    //     }
    // }

    async function login(user) {
        try {
            const data = await api.post('/users/login', user).then((response) => response.data);
    
            // Salvar token no localStorage e configurar headers
            localStorage.setItem('token', JSON.stringify(data.token));
            api.defaults.headers.Authorization = `Bearer ${data.token}`;
            setAuthenticated(true);
    
            // Redirecionar com base no role do usuário
            if (data.role === 'tecnico') {
                navigate('/app/myrequests');
            } else if (data.role === 'warehouse') {
                // Se for mobile (exemplo: largura <= 600px), redireciona para homeentregador
                if (window.innerWidth <= 600) {
                    navigate('/app/homeentregador');
                } else {
                    navigate('/app/warehouse');
                }
            } else if (data.role === 'entregador') {
                navigate('/app/homeentregador');
            } else if (data.role === 'report-reader') {
                navigate('/app/report1');
            }else {
                navigate('/app');
            }
    
            // Mostrar mensagem de sucesso
            toast.success('Login realizado com sucesso!');
        } catch (error) {
            // Mostrar mensagem de erro
            toast.error('Ops! ' + error.response.data.message);
        }
    }
    

    function logout(){

        setAuthenticated(false)
        localStorage.removeItem('token')
        api.defaults.headers.Authorization = undefined

        const message = 'Logout realizado com sucesso!'

        toast.success(message, {
            // position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        
        navigate('/login')
        // window.location.href = '/login';

    }

    async function changePassword({ password, newPassword, confirmNewPassword }) {
        // if (newPassword !== confirmNewPassword) {
        //     toast.error("As senhas não conferem.");
        //     return;
        // }
    
        try {
            await api.patch('/users/change-password', {
                password,
                newPassword
            });
            
            toast.success("Senha alterada com sucesso!");
            navigate('/app');
        } catch (error) {
            // console.error("Erro ao alterar a senha:", error);
            toast.error(error.response.data.message);
        }
    }

    return { authenticated, createUser, login, logout, user, setUser, changePassword }

}
